export default __webpack_public_path__ + "static/media/bandeau-catalogue-desktop-es.ce7b6e88.png";